
import React from 'react';
import { Divider } from '@mui/material';
import { useParams } from 'react-router-dom';
import { toast } from 'react-toastify';
import PrepaymentDetailTab from './PrepaymentComponents/PrepaymentDetailTab';
import EnableDisableButton from 'components/Shared/EnableDisableButton';
import BreadcrumbLayout from 'layouts/BreadcrumbLayout';
import PrepaymentBasicDetail from './PrepaymentComponents/PrepaymentBasicDetail';
import {
  useGetPrepaymentDetailQuery,
  useUpdatePrepaymentMutation,
} from 'store/services/PaymentsApi/prepaymentApi';
import {
  PrepaymentDetailContext,
  usePrepaymentDetailContext,
} from 'contexts/PrepaymentDetailContext';
import { useAuth } from 'hooks';

const PrepaymentDetailScreen = () => {
  const { id } = useParams();
  const { isVendor } = useAuth();

  const {
    data: prepaymentDetail,
    isLoading: loadingPrepayment,
    error,
    refetch,
  } = useGetPrepaymentDetailQuery(id);

  const breadcrumb = [
    {
      title: 'Prepayment',
      path: !isVendor
        ? '/app/crm/prepayment/list'
        : '/app/vendor/prepayment/list',
    },
    { title: 'Prepayment Detail' },
  ];

  return (
    <PrepaymentDetailContext.Provider
      value={{ prepaymentDetail, loadingPrepayment, refetch }}
    >
      <BreadcrumbLayout
        breadcrumbs={breadcrumb}
        isBusy={loadingPrepayment}
        headerActions={<PageActions />}
      >
        <BreadcrumbLayout.Error error={error} />
        <BreadcrumbLayout.Paper>
          <PrepaymentBasicDetail />
          <Divider />
          <PrepaymentDetailTab />
        </BreadcrumbLayout.Paper>
      </BreadcrumbLayout>
    </PrepaymentDetailContext.Provider>
  );
};

export default PrepaymentDetailScreen;

const PageActions = () => {
  const { isVendor } = useAuth();
  const { prepaymentDetail, loadingPrepayment } = usePrepaymentDetailContext();
  const [updatePrepayment, { isLoading: updatingPrepayment }] =
    useUpdatePrepaymentMutation();
  const handleToggleStatus = async () => {
    try {
      await updatePrepayment({
        _id: prepaymentDetail?._id,
        isActive: !prepaymentDetail?.isActive,
      }).unwrap();
      toast.info(
        `Prepayment ${prepaymentDetail?.isActive ? 'Disabled' : 'Enabled'}!`
      );
    } catch (error) {
      toast.error(error?.data?.message ?? 'Could not update status');
    }
  };
  return (
    <>
      {!isVendor && (
        <div className="flex space-x-4">
          {prepaymentDetail?.amount === prepaymentDetail?.balanceAmount && (
            <EnableDisableButton
              isActive={prepaymentDetail?.isActive}
              loading={loadingPrepayment || updatingPrepayment}
              onClick={handleToggleStatus}
            />
          )}
        </div>
      )}
    </>
  );
};